import { string, object, array, boolean } from 'yup';

const offTimeSchema = object().shape({
  date: string().required(),
  times: array(),
  allDay: boolean()
});

export default offTimeSchema;
